import type { IconData } from '@stacksjs/iconify-core'

export const ipadTabletScreenSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.143 4.966C11.408 4.74 16.597 4.5 24 4.5s12.592.239 15.857.466s5.862 2.693 6.152 5.993c.249 2.835.491 7.115.491 13.041s-.242 10.206-.491 13.041c-.29 3.3-2.887 5.765-6.152 5.993c-3.265.227-8.454.466-15.857.466s-12.592-.239-15.857-.466s-5.862-2.693-6.152-5.993C1.742 34.206 1.5 29.926 1.5 24s.242-10.206.491-13.041c.29-3.3 2.887-5.765 6.152-5.993M15 34a2 2 0 1 0 0 4h18a2 2 0 1 0 0-4z\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default ipadTabletScreenSolid
